import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {CategoryModelServer, Category as CategoryModel} from "../models/category.model";
// Create a Category model or interface (optional, shown below)
export interface Category {
  id: number;
  title: string;
  description?: string;
  image?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
 
  private SERVER_URL = environment.SERVER_URL;
  constructor(private http: HttpClient) {}

  // Get all categories
  getAllCategories(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(this.SERVER_URL+ 'categories', {
        });
  }
  
 // GET categories where cat_top = 'no'
  getCategories(): Observable<CategoryModel[]> {
    return this.http.get<CategoryModel[]>(this.SERVER_URL+ 'categories/cat', {
        });
  }

  // get submenus
  getMenuWithSubmenus(): Observable<any[]> {
  return this.http.get<any[]>(this.SERVER_URL+ 'categories/menus-with-submenus');
}

  // Get category by ID
//   getCategoryById(id: number): Observable<CategoryModel> {
//     return this.http.get<CategoryModel>(`${this.SERVER_URL}/${id}`);
//   }

  /* GET -> Un singur produs din server */
  getCategoryById(id: number): Observable<CategoryModel>
  {
    return this.http.get<CategoryModel>(this.SERVER_URL + 'categories/' + id);
  }

  
  // (Optional) Create a new category
  createCategory(data: Category): Observable<any> {
    return this.http.post(this.SERVER_URL, data);
  }

  // (Optional) Update a category
  updateCategory(id: number, data: Category): Observable<any> {
    return this.http.put(`${this.SERVER_URL}/${id}`, data);
  }

  // (Optional) Delete a category
  deleteCategory(id: number): Observable<any> {
    return this.http.delete(`${this.SERVER_URL}/${id}`);
  }
}
